const point = "https://flint-backend.cuba-go.com"

/* REST API POINT */
const startpoint = `${point}/`
const socketpoint = `${point}`

export { point, startpoint, socketpoint }